import { BrowserRouter } from "react-router-dom";

import { SettingsProvider } from "./apps/publishing/context/SettingsContext";
import AppRoutes from "./routes/AppRoutes";
import { MediaProvider } from "./apps/media/MediaContext";

import "./styles/App.css";

export default function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
        <div className="App">
          <div className="pageContent">
            <MediaProvider><AppRoutes /></MediaProvider>
          </div>
        </div>
      </SettingsProvider>
    </BrowserRouter>
  );
}
